import { render } from "./VGVoiceExplorerModal.vue?vue&type=template&id=15f4691e&scoped=true"
import script from "./VGVoiceExplorerModal.vue?vue&type=script&lang=js"
export * from "./VGVoiceExplorerModal.vue?vue&type=script&lang=js"

import "./VGVoiceExplorerModal.vue?vue&type=style&index=0&id=15f4691e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f4691e"]])

export default __exports__